import type { PostData } from '@mogul/api-client';
import { PostType } from '@mogul/api-client';
import { DefaultAvatar } from '@mogul/shared';

import defaultEventImg from '../../common/images/community/event.jpg';
import defaultUpdateImg from '../../common/images/community/updates.jpg';
import styles from './PostListing.module.css';

export interface PostListingProps {
  post: PostData;
}

export const PostListing = (props: PostListingProps) => {
  const { post } = props;

  const { eventDate, body, title, headerImage, type } = post;

  return (
    <div className={styles.postListing}>
      <img
        src={
          headerImage?.publicUrl
            ? headerImage.publicUrl
            : type === PostType.Update
            ? defaultUpdateImg
            : defaultEventImg
        }
        alt="event listing"
        className={styles.postImage}
      />
      <h1 className={styles.postTitle}>{title}</h1>
      <p className={styles.postBody}>{body}</p>
      <div className={styles.postDateSpacing}>
        <img
          src={DefaultAvatar}
          alt="listing profile"
          className={styles.postProfileImage}
        />
        {eventDate != null && type === PostType.Event && (
          <p className={styles.postDate}>
            {new Date(eventDate).toLocaleString('default', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
              formatMatcher: 'basic',
            })}
          </p>
        )}
      </div>
    </div>
  );
};
